import React, { Suspense, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import SideNav from "components/layout-components/SideNav";
import TopNav from "components/layout-components/TopNav";
import Loading from "components/shared-components/Loading";
//import MobileNav from "components/layout-components/MobileNav";
// eslint-disable-next-line no-unused-vars
import HeaderNav from "components/layout-components/HeaderNav";
// eslint-disable-next-line no-unused-vars
import PageHeader from "components/layout-components/PageHeader";
import Footer from "components/layout-components/Footer";
import {
  Layout,
  Grid,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Input,
  message,
} from "antd";
import navigationConfig from "configs/NavigationConfig";
import { TEMPLATE, MEDIA_QUERIES, LABELS } from "constants/ThemeConstant";
import styled from "@emotion/styled";
import utils from "utils";
//import image from "../assets/images/tcblbackground.png";
//import logo from "../assets/images/log.svg";
//import locBackground from "../assets/images/locBackground.png";
import MatchHeader from "../views/app-views/matchHeader";
import axios from "axios";
import { env } from "configs/EnvironmentConfig";
import ApiConfig from "configs/ApiConfig";

const { Content } = Layout;
const { useBreakpoint } = Grid;

export const AppLayout = ({ navCollapsed, navType, direction, children }) => {
  const location = useLocation();
  const [imagesfromdb, setimagesfromdb] = useState({});
  const getHomeImage = async () => {
    const { data } = await axios.get(
      `${env?.API_ENDPOINT_URL}/${ApiConfig.website.getWebsiteInfo}`
    );
    console.log(data, "datadata221");
    const background = data?.bannerList?.find((item) => item.type === "Banner");
    const landing = data?.bannerList?.filter(
      (item) => item.type === "Landing_Page"
    );
    const sidebar = data?.bannerList?.filter((item) => item.type === "sidebar");
    const total = { background, landing, sidebar };
    console.log(background, "datadata2212");
    setimagesfromdb({ ...total });
  };
  useEffect(() => {
    getHomeImage();
  }, []);
  console.log(
    imagesfromdb,
    "imagesfromdb?.background?.banner_image1imagesfromdb?.background?.banner_image1"
  );
  const AppContent = styled("div")`
    padding: ${TEMPLATE.LAYOUT_CONTENT_GUTTER}px;
    margin-top: ${TEMPLATE.HEADER_HEIGHT}px;
    min-height: calc(100vh - ${TEMPLATE.CONTENT_HEIGHT_OFFSET}px);
    position: relative;
    background-image: url("${process.env.REACT_APP_DEV_API_REDIRECT_URL.includes(
      "tcbl"
    )
      ? imagesfromdb?.background?.banner_image1
      : `https://leaguepro.s3.ca-central-1.amazonaws.com/team-logos/loc_website_bg.jpg`}");
    background-repeat: no-repeat;
    background-size: 100% auto;

    ${(props) =>
      props.isNavTop
        ? `
        max-width: ${TEMPLATE.CONTENT_MAX_WIDTH}px;
        margin-left: auto;
        margin-right: auto;
        width: 100%;

        @media ${MEDIA_QUERIES.DESKTOP} { 
            margin-top: ${TEMPLATE.HEADER_HEIGHT + TEMPLATE.TOP_NAV_HEIGHT}px;
            min-height: calc(100vh - ${TEMPLATE.CONTENT_HEIGHT_OFFSET}px - ${
            TEMPLATE.TOP_NAV_HEIGHT
          }px);
        }
    `
        : ""}

    @media ${MEDIA_QUERIES.MOBILE} {
      padding: ${TEMPLATE.LAYOUT_CONTENT_GUTTER_SM}px;
    }
  `;

  const currentRouteInfo = utils.getRouteInfo(
    navigationConfig,
    location.pathname
  );
  const screens = utils.getBreakPoint(useBreakpoint());
  const isMobile = screens.length === 0 ? false : !screens.includes("lg");
  //const isTab = screens.length === 0 ? false : !screens.includes("md");
  // eslint-disable-next-line no-unused-vars
  const isNavSide = navType === TEMPLATE.NAV_TYPE_SIDE;
  const isNavTop = navType === TEMPLATE.NAV_TYPE_TOP;
  const getLayoutGutter = () => {
    if (isNavTop || isMobile) {
      return 0;
    }
    return navCollapsed
      ? TEMPLATE.SIDE_NAV_COLLAPSED_WIDTH
      : TEMPLATE.SIDE_NAV_WIDTH;
  };

  const getLayoutDirectionGutter = () => {
    if (direction === TEMPLATE.DIR_LTR) {
      return { paddingLeft: getLayoutGutter() };
    }
    if (direction === TEMPLATE.DIR_RTL) {
      return { paddingRight: getLayoutGutter() };
    }
    return { paddingLeft: getLayoutGutter() };
  };

  const [openSupportModal, setOpenSupportModal] = useState(false);
  const [form] = Form.useForm();
  const onSubmit = async (values) => {
    const submitIssue = await axios.post(
      `${env?.API_ENDPOINT_URL}/settings/customer-register-mail`,
      { ...values }
    );
    console.log(submitIssue);
    message.success("Our Team will contact you");
    setOpenSupportModal(false);
    form.resetFields();
  };
  const [settings, setsettings] = useState({});
  // eslint-disable-next-line no-unused-vars
  const getaccountsettings = async () => {
    try {
      const response = await axios.get(
        `${env?.API_ENDPOINT_URL}/${ApiConfig.website.getaccountsettings}`
      );
      setsettings({ ...response?.data?.[0] });
      // form.setFieldsValue({homepage:response?.data?.[0]?.homepage,
      //   home:response?.data?.[0]?.hiddenmenu?.includes("/home"),
      //   rule:response?.data?.[0]?.hiddenmenu?.includes("/rule"),
      //   portal:response?.data?.[0]?.portal,
      //   rulelink:response?.data?.[0]?.rule
      // })
    } catch (error) {
      return [];
    }
  };
  useEffect(() => {
    getaccountsettings();
  }, []);
  const HeaderItem = () => {
    return (
      <>
        <div
          style={{
            minHeight: "170px",
            margin: "-25px 17% 0% 17%",
            background:
              "linear-gradient(90deg, rgba(0,0,0,1) 41%, rgba(0,0,0,0.5) 100%)",
          }}
        >
          <Row>
            <Col xs={12} sm={12} md={4}>
              <div style={{ marginLeft: "20px", marginTop: "20px" }}>
                <img
                  style={{ backgroundColor: "#000" }}
                  src={settings?.logo}
                  alt="logo"
                  height={
                    process.env.REACT_APP_DEV_API_REDIRECT_URL.includes("tcbl")
                      ? "70px"
                      : "120px"
                  }
                />
              </div>
            </Col>
            <Col xs={12} sm={12} md={20}>
              <div
                style={
                  true
                    ? {
                        fontSize: "12pt",
                        color: "red",
                        fontWeight: "700",
                        marginTop: "20px",
                      }
                    : {
                        fontSize: "16pt",
                        color: "red",
                        fontWeight: "700",
                        marginTop: "20px",
                      }
                }
              >
                Official Site of
              </div>
              <div
                style={
                  true
                    ? {
                        fontSize: "16pt",
                        color: "#FFF",
                        fontWeight: "700",
                        marginTop: "10px",
                      }
                    : {
                        fontSize: "24pt",
                        color: "#FFF",
                        fontWeight: "700",
                        marginTop: "10px",
                      }
                }
              >
                {process.env.REACT_APP_DEV_API_REDIRECT_URL.includes("tcbl")
                  ? LABELS?.TCBL?.FULLNAME
                  : LABELS?.LOC?.FULLNAME}
              </div>
              {/* {((process.env.REACT_APP_DEV_API_REDIRECT_URL).includes('tcbl')) && <Button onClick={()=>setOpenSupportModal(true)} style={{backgroundColor:'black',marginTop:'20px',color:'white',borderRadius:'0px',border:'3px solid white',fontSize:'16px',padding:'5px',fontWeight:'700',transform:"skew(-10deg)",position:'absolute',top:'0px',right:'135px'}}>
            Register New Team
            </Button>} */}
              {process.env.REACT_APP_DEV_API_REDIRECT_URL.includes("tcbl") && (
                <Button
                  href={`https://${settings?.portal}`}
                  style={{
                    backgroundColor: "black",
                    marginTop: "20px",
                    color: "white",
                    borderRadius: "0px",
                    border: "3px solid white",
                    fontSize: "16px",
                    padding: "5px",
                    fontWeight: "700",
                    transform: "skew(-10deg)",
                    position: "absolute",
                    top: "0px",
                    right: "10px",
                  }}
                >
                  Login / Signup
                </Button>
              )}
            </Col>
            {/* <Col xs={12} sm={12} md={2}>
            
          </Col> */}
          </Row>
          <Modal
            open={openSupportModal}
            onCancel={() => setOpenSupportModal(false)}
            okText="Submit"
            title="New Registration"
            maskClosable={false}
            footer={null}
          >
            <Form
              form={form}
              onFinish={onSubmit}
              wrapperCol={{
                span: 18,
              }}
              labelCol={{
                span: 6,
              }}
              labelAlign="left"
              onS
            >
              <Form.Item
                name="name"
                label="Name"
                rules={[
                  {
                    required: true,
                    message: "Please input your name",
                  },
                ]}
              >
                <Input placeholder="Name" />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[
                  {
                    required: true,
                    message: "Please input your Email",
                  },
                ]}
              >
                <Input placeholder="Email" />
              </Form.Item>
              <Form.Item
                name="phone"
                label="Phone"
                rules={[
                  {
                    required: true,
                    message: "Please input your Phone",
                  },
                ]}
              >
                <Input placeholder="Phone" />
              </Form.Item>
              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: "20px",
                }}
              >
                <Button onClick={() => setOpenSupportModal(false)}>
                  Cancel
                </Button>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </div>
            </Form>
          </Modal>
        </div>
      </>
    );
  };

  return (
    <div>
      <Layout>
        {isMobile ? (
          <HeaderNav isMobile={isMobile} currentRouteInfo={currentRouteInfo} />
        ) : null}
        <Layout>
          {/* {(isNavSide && !isMobile) ? <SideNav routeInfo={currentRouteInfo}/> : null } */}
          <Layout style={getLayoutDirectionGutter()}>
            {!isMobile ? <MatchHeader /> : null}
            <AppContent>
              {!isMobile ? <HeaderItem /> : null}
              {/* <PageHeader display={currentRouteInfo?.breadcrumb} title={currentRouteInfo?.title} /> */}
              <Content className="h-100">
                <div
                  style={{
                    margin: !isMobile
                      ? "-5% 17% 5% 17%"
                      : "-5% -10px 0px -10px",
                  }}
                >
                  {!isMobile ? <TopNav routeInfo={currentRouteInfo} /> : null}
                  <Suspense fallback={<Loading cover="content" />}>
                    {children}
                  </Suspense>
                </div>
              </Content>
            </AppContent>

            <Footer />
          </Layout>
        </Layout>
        {/* {isMobile && <MobileNav />} */}
      </Layout>
    </div>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navCollapsed, navType, locale } = theme;
  return { navCollapsed, navType, locale };
};

export default connect(mapStateToProps)(React.memo(AppLayout));
